export const colors = {
  black: "#000000",
  white: "#ffffff",
  golden: "#f4d03f",
  veryLightBrown: "#f9f4f1",
  vanDykeBrown: "#6a3e2a",
  burgundy: "#b03a2e",
  navyBlue: "#024a92",
  gray: "#cccccc",
};

export const rgbaColors = {
  black: "0,0,0",
  white: "255,255,255",
  vanDykeBrown: "106,62,42",
};
